export const staffMembers = [
  {
    name: "Ditte-Marie Thejsen",
    role: "Skoleleder",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7245.jpg",
    email: "dmt@odderlillefriskole.dk",
    phone: "86 54 38 66"
  },
  {
    name: "Mikkel Boritz Kristiansen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7133.jpg",
    subjects: "Matematik, Fysik/Kemi, Idræt"
  },
  {
    name: "Clara Brunhøj Bjerregaard",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7200.jpg",
    subjects: "Dansk, Engelsk, Musik"
  },
  {
    name: "Krestine Søndergaard",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7165.jpg",
    subjects: "Dansk, Billedkunst, Historie"
  },
  {
    name: "Niklas Rander",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7254.jpg",
    subjects: "Natur/Teknologi, Geografi, Matematik"
  },
  {
    name: "Hannes Lichtenwald",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7206.jpg",
    subjects: "Tysk, Samfundsfag, Historie"
  },
  {
    name: "Tea Stenmann Jensen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7180.jpg",
    subjects: "Dansk, Håndværk & Design"
  },
  {
    name: "Jesper Brems Olesen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/jesper-olesen-d35ab2db.jpeg",
    subjects: "Musik, Matematik, Svømning"
  },
  {
    name: "Alex Martin Nielsen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/alex-nielsen-04a0df82.jpeg",
    subjects: "Historie, Dansk, Idræt"
  },
  {
    name: "Jeanette Brunhøj Bjerregaard",
    role: "Pædagog / Fritteren",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/woman-ef7a041b-kopi.jpeg",
    subjects: "Fritidsordning & Klub"
  },
  {
    name: "Tue Rasmussen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/tue-rasmussen-5ec7bcd1.jpeg",
    subjects: "Naturfag, Matematik"
  },
  {
    name: "Trine Bille",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/trine-bille-ee3ea5c0.jpeg",
    subjects: "Dansk, Læsevejleder"
  },
  {
    name: "Nicolaj Quist Lauritzen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/nicolaj-quist-lauritzen-1b77b4b4.jpeg",
    subjects: "Idræt, Friluftsliv, Matematik"
  },
  {
    name: "Marianne Sønderstrup-Jensen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/marianne-soenderstrup-jensen-ecbe88ef.jpeg",
    subjects: "Dansk, Religion, Trivsel"
  },
  {
    name: "Mette Nygaard Petersen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/mette-petersen-1c8449bc.jpeg",
    subjects: "Engelsk, Tysk"
  },
  {
    name: "Mette Baunhøj Knudsen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/mette-knudsen-65ba5d27.jpeg",
    subjects: "Indskoling, Dansk, Matematik"
  },
  {
    name: "Kristian Niemann-Nielsen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/5-1-c7688842-41254af5.jpeg",
    subjects: "Musik, Håndværk"
  },
  {
    name: "David Kildekær",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/david-kildekaer-708f71d2.jpeg",
    subjects: "Matematik, Idræt"
  },
  {
    name: "Anne-Birgit Albertsen",
    role: "Lærer",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/anne-birgit-albertsen-9b73d1f2.jpeg",
    subjects: "Dansk, Særlig støtte"
  },
  {
    name: "Dorte Holm Hansen",
    role: "Pædagog",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/img-3374.jpg",
    subjects: "Fritteren & Børnehaveklasse"
  },
  {
    name: "Dorthe Redder",
    role: "Pædagog",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dorthe-redder-4feed218.jpeg",
    subjects: "Fritteren & Inklusion"
  },
  {
    name: "Jane Lykke Jørgensen",
    role: "Sekretariat & Administration",
    image: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/jane-lykke-joergensen-12b21e51.jpeg",
    subjects: "Administration & Forældrehenvendelser"
  }
];
